import React from 'react';
import { Box } from '@mui/material';
import { CountryDropdown, ValidatedTextInput } from './ValidatedInputs';

const style = { margin: '4px 0' };

/**
 * Combined phone prefix dropdown and number input, rendered next to each other with no gap.
 * Props: prefixValue (country object), numberValue (string), countries, onChange(id, value, valid),
 * disableError, loading, sx.
 */
const PhoneNumberInput = ({
  prefixValue,
  numberValue = '',
  countries = [],
  onChange,
  disableError,
  loading,
  sx,
}) => {
  const onPrefixChange = (id, country, valid) => {
    onChange(id, country?.phonePrefix ?? '', valid);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 0,
        width: '100%',
        ...sx,
      }}
    >
      <CountryDropdown
        id="countryPrefix"
        value={prefixValue}
        onChange={onPrefixChange}
        countries={countries}
        required
        sx={style}
        disableError={disableError}
        disabled={loading}
        textFieldProps={{
          label: 'Prefiks',
          size: 'small',
          sx: {
            width: 140,
            minWidth: 140,
            '& .MuiOutlinedInput-root': {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            },
          },
        }}
        getOptionLabel={(country) => country.phonePrefix}
        getOptionText={(country) => `${country.phonePrefix} ${country.name}`}
        filterOptions={(countriesList, { inputValue }) =>
          countriesList.filter(
            (c) =>
              c.name?.toLowerCase().includes(inputValue?.toLowerCase()) ||
              c.phonePrefix?.toLowerCase().includes(inputValue?.toLowerCase())
          )
        }
      />
      <ValidatedTextInput
        fullWidth
        size="small"
        id="phoneNumber"
        onChange={onChange}
        label="Numer telefonu"
        required
        sx={{
          ...style,
          flex: '1 1 auto',
          minWidth: 0,
          '& .MuiOutlinedInput-root': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
        value={numberValue}
        disableError={disableError}
        disabled={loading}
        phoneNumber
      />
    </Box>
  );
};

export default PhoneNumberInput;
